// https://app.growthbook.io/features/prcng-521_v2
export const COLLAPSED_PAINTED_DOOR_FLAG_NAME = 'prcng-521_v2'
